import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-dotzot-create',
  templateUrl: './admin-dotzot-create.component.html',
  styleUrls: ['./admin-dotzot-create.component.scss'],
})
export class AdminDotzotCreateComponent implements OnInit {
  carrierName: string;
  carrierNameError: string;
  customerCode: string;
  customerCodeError: string;
  userName: string;
  userNameError: string;
  password: string;
  passwordError: string;
  createOrderToken: string;
  createOrderTokenError: string;
  cancelOrderToken: string;
  cancelOrderTokenError: string;
  trackOrderURL: string;
  trackOrderURLError: string;
  trackOrderToken: string;
  trackOrderTokenError: string;
  token: string;
  tokenError: string;

  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }

  tokenBlur() {
    this.tokenError = "";
    if (!this.token) {
      this.tokenError = 'Please enter token';
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }


  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }

  userNameBlur() {
    this.userNameError = "";
    if (!this.userName) {
      this.userNameError = 'Please enter user name';
    }
  }

  passwordBlur() {
    this.passwordError = "";
    if (!this.password) {
      this.passwordError = 'Please enter password';
    }
  }

  createOrderTokenBlur() {
    this.createOrderTokenError = "";
    if (!this.createOrderToken) {
      this.createOrderTokenError = 'Please enter create order token';
    }
  }

  cancelOrderTokenBlur() {
    this.cancelOrderTokenError = "";
    if (!this.cancelOrderToken) {
      this.cancelOrderTokenError = 'Please enter cancel order token';
    }
  }

  trackOrderURLBlur() {
    this.trackOrderURLError = "";
    if (!this.trackOrderURL) {
      this.trackOrderURLError = 'Please enter track order URL';
    }
  }

  trackOrderTokenBlur() {
    this.trackOrderTokenError = "";
    if (!this.trackOrderToken) {
      this.trackOrderTokenError = 'Please enter track order token';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.tokenError = "";
    this.customerCodeError = "";
    this.userNameError = "";
    this.passwordError = "";
    this.createOrderTokenError = "";
    this.cancelOrderTokenError = "";
    this.trackOrderURLError = "";
    this.trackOrderTokenError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.token) {
      this.tokenError = 'Please enter token';
    }
    /*
           if (!this.customerCode) {
               this.customerCodeError = 'Please enter customer code';
           }
           if (!this.userName) {
               this.userNameError = 'Please enter user name';
           }
          if (!this.password) {
            this.passwordError = 'Please enter password';
          }
          if (!this.createOrderToken) {
              this.createOrderTokenError = 'Please enter create order token';
           }
           if (!this.cancelOrderToken) {
               this.cancelOrderTokenError = 'Please enter cancel order token';
           }
          if (!this.trackOrderURL) {
            this.trackOrderURLError = 'Please enter track order URL';
          }
          if (!this.trackOrderToken) {
            this.trackOrderTokenError = 'Please enter track order token';
          }
          if (this.carrierNameError != "" ||this.createOrderTokenError != "" ||this.customerCodeError != "" ||this.userNameError != "" ||this.cancelOrderTokenError != "" ||this.passwordError != "" ||this.trackOrderURLError != "" ||this.trackOrderTokenError != "") {
            this.g.loaderDisplay = "";
            return false;
          }
     */
    if (this.carrierNameError != "" || this.createOrderTokenError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {
      "connectionName": this.carrierName,
      "carrierCode": "DZ",
      "organizationId": 1,
      "token": this.token
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('DotZot', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

